import * as React from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"

import Card from "../components/homepage/Card"
import Hero from "../components/homepage/Hero"
import Grid from "../components/homepage/Grid"
import Experience from "../components/homepage/Experience"
import Form from "../components/homepage/Form"

const cards = [
  {
    size: "xs",
    price: 200,
    title: "Basic",
    color: "black",
    options: [
      "Studio",
      "I give all the high-quality images",
      "Retouching",
      "Web version of the photo",
      "Photo in b / w processing (color optional)",
    ],
  },
  {
    size: "s",
    price: 500,
    title: "Standart",
    color: "blue",
    options: [
      "Studio, street, park",
      "I give all the high-quality images",
      "Retouching",
      "Web version of the photo",
      "Photo in b / w processing (color optional)",
      "10 printed photos (15 * 20 cm)",
      "Photo on flash drive and handmade packaging",
    ],
  },
  {
    size: "xs",
    price: 800,
    title: "Expert",
    color: "black",
    options: [
      "Studio, street, park",
      "I give all the high-quality images",
      "Retouching",
      "Web version of the photo",
      "Photo in processing (color optional)",
      "20 printed photos (15 * 20 cm)",
      "Photo on flash drive and handmade packaging",
      "Photobook 20 * 20 cm in a photo cover",
    ],
  },
]

const HomePage = () => (
  <Layout>
    <Seo title="Home" />
    <div className="desktop mx-3 md:mx-auto">
      <Hero />

      <div className="w-full mt-10 mb-16 md:mt-14 md:mb-20 lg:mt-[61px] lg:mb-[135px]">
        <p className="text-black text-[16px] font-light font-ubuntu">
          My name is Anna. I’m photographer with passion to landscape photo,
          studio photo and portraits. I’ve started taking photos at my earcly
          childhood, when I found old Polaroid camera.
        </p>
      </div>

      <Grid />
    </div>

    <Experience />

    <div className="desktop mt-16 mb-8 mx-3 md:mx-auto lg:mt-[88px] lg:mb-[95px]">
      <h2 className="font-playfair font-black text-[36px] text-black text-center mb-20 lg:mb-[110px]">
        Studio Price
      </h2>

      <div className="flex justify-around w-full flex-wrap lg:flex-nowrap">
        {cards.map(card => (
          <Card {...card} key={card.title} />
        ))}
      </div>
    </div>

    <Form>
      <h1 className="font-playfair font-black text-[36px] text-white text-center mb-[55px]">
        Book my time
      </h1>
    </Form>
  </Layout>
)

export default HomePage
